import Body from "./BodyV2";
import InnerPageLayout from "../../../components/layouts/InnerPageLayout";

const OnboardVehicleOwner = () => {

  return (
    <InnerPageLayout>
       <Body />
    </InnerPageLayout>
  );
}

export default OnboardVehicleOwner;
